import React from 'react';
import {
  Box,
  Typography,
  useTheme,
  Link,
  Icons,
} from '@ublend-npm/aulaui-core';
import { getStarredSpaceColors } from '../../colors';

interface StarredSpacesEmptyStateProps {
  helpArticleUrl?: string;
  onTrigger?: () => void;
}

const STRINGS = {
  startSpaceEasy: 'Star spaces to keep them easy to find.',
  learnHow: ' Learn how to star spaces here (link to HC article)',
};

const StarredSpacesEmptyState: React.FC<StarredSpacesEmptyStateProps> = ({
  helpArticleUrl = '#',
  onTrigger,
}) => {
  const { palette } = useTheme();
  const colors = getStarredSpaceColors(palette);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      bgcolor={colors.emptyPanelBg}
      borderRadius="0.5rem"
      px={{ xs: 2, md: 3 }}
      pt={{ xs: 2, md: 3 }}
      pb="16px"
      flex={1}
      width="100%"
      minHeight="200px"
      sx={{
        transition: 'background-color 0.2s',
      }}
    >
      <Box
        mt="18px"
        onClick={onTrigger}
        sx={{
          cursor: onTrigger ? 'pointer' : 'inherit',
          '&:hover': onTrigger ? { opacity: 0.8 } : {},
        }}
        role={onTrigger ? 'button' : undefined}
        tabIndex={onTrigger ? 0 : undefined}
        onKeyDown={(e) => {
          if (onTrigger && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onTrigger();
          }
        }}
      >
        <Icons.AddButtonIcon
          mode={palette.mode === 'dark' ? 'dark' : 'light'}
        />
      </Box>

      <Typography
        mt="8px"
        mb={1}
        color={colors.emptyTitleColor}
        sx={{
          fontFamily: (theme) => theme.typography.fontFamily,
          fontWeight: 'regular',
          fontStyle: 'normal',
          fontSize: '1rem',
          lineHeight: '175%',
          letterSpacing: '0.15px',
          textAlign: 'center',
        }}
      >
        {STRINGS.startSpaceEasy}
      </Typography>

      <Link
        href={helpArticleUrl}
        newTab
        rel="noopener noreferrer"
        sx={{
          color: colors.linkColor,
          textDecoration: 'underline',
          textDecorationStyle: 'solid',
          textUnderlineOffset: '3px',
          fontWeight: 'regular',
          fontStyle: 'normal',
          fontFamily: (theme) => theme.typography.fontFamily,
          cursor: 'pointer',
          fontSize: '0.75rem',
          lineHeight: '12px',
          letterSpacing: '0px',
          textAlign: 'center',
        }}
      >
        {STRINGS.learnHow}
      </Link>
    </Box>
  );
};

export default StarredSpacesEmptyState;
